export default "__VITE_ASSET__DX67QXiV__"